import {combineReducers} from "redux"
import cartReducer from "./cartReducer"
import langReducer from "./langReducer";

const rootReducers = combineReducers({
    cartReducer,
    langReducer
})

export default rootReducers;